<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20">
			<div class="title_shaixuan flex_jc_center">团队规模</div>
			<div class="classified_content" :style="{height:show?'auto':'46px'}" ref="height">
        <div class="unfold flex_ai_center" :class="show?'unfold-red':''" @click="show=!show" v-if="height">
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
				<span v-for="(item, index) in teamSize" :key="'teamSize'+index" :class="{ pitch_on: teamIndex==index }"
              @click="send(item, index)">
					{{ item.ranges }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {apiResignAll} from "@/api/apiResignAll"
	export default {
		name: "teamSize",
		data() {
			return {
				teamSize: [],
				teamIndex: '',
        show:true,
        height:false,
			}
		},
    computed:{
      teamSizeType(){
        return this.$parent.teamSizeType
      }
    },
		watch: {
      teamSizeType:function (v){
        this.teamIndex='';
		    if(v==='')return;
		    this.getteamSizeOption();
      }
    },
		created() {
			this.getteamSizeOption()
		},
		methods: {
			/** @name 获取分类数据 */
			async getteamSizeOption() {
        if(!this.$store.state['HC_teamSize'+this.$parent.teamSizeType]){
          let res = await apiResignAll.getteamSizeOption(this.$parent.teamSizeType)
          if (res && res.data && res.data.code === 200) {
            this.teamSize = [{no: null,ranges: "全部"},...res.data.data];
            this.$store.state['HC_teamSize'+this.$parent.teamSizeType]= [{no: null,ranges: "全部"},...res.data.data]
          }
        }else{
          this.teamSize = this.$store.state['HC_teamSize'+this.$parent.teamSizeType]
        }
        this.$nextTick(v=>{
          if(!this.$refs.height)return;
          this.height=this.$refs.height.offsetHeight>46;
          this.show=!this.height;
        })
			},
			/** @name 搜索单项 */
			send(obj, key) {
        this.teamIndex = key;
        if(key==0){
          this.$parent.$refs.screen.teamSize=[]
          return
        }
        obj.key = key;
				//替换搜索项
				let type = this.$parent.$refs.screen.teamSize.length;
				if (type) {
					this.$parent.$refs.screen.teamSize.splice(0, 1, obj)
					return
				}
				//添加搜索项
				this.$parent.$refs.screen.teamSize.push(obj)
			},
			/** @name 清队单项 */
			close(item) {
				this.teamIndex = ''
			},
			/** @name 清空所有 */
			closeall() {
				this.teamIndex = ''
			}
		},
	}
</script>

<style scoped>

</style>
